import * as React from 'react';
import { Section } from './section';
import { TextareaField } from './textarea-field';
import {
  CommonAction,
  CommonReducerState
} from '@/features/line-items/line-item-form/common/form-reducer';
import { Dispatch } from 'react';

type AdInfoSectionProps = {
  state: CommonReducerState;
  dispatch: Dispatch<CommonAction>;
  errorFor: (field: string) => string | undefined;
};

export function AdInfoSection({ state, dispatch, errorFor }: AdInfoSectionProps) {
  return (
    <Section heading="Ad Information">
      <div data-testid="ad-info-row-1" className="flex gap-8">
        <div className="flex-1">
          <TextareaField
            id="line-item-geo"
            label="Geo"
            value={state.formData.geo}
            placeholder="Define Geo"
            rows={2}
            onChange={value => dispatch({ type: 'SET_GEO', value })}
            onBlur={() => dispatch({ type: 'BLUR_FIELD', field: 'geo' })}
            error={errorFor('geo')}
          />
        </div>
        <div className="flex-1">
          <TextareaField
            id="line-item-targeting"
            label="Targeting (Optional)"
            value={state.formData.targeting}
            placeholder="Define Targeting"
            rows={2}
            onChange={value => dispatch({ type: 'SET_TARGETING', value })}
            onBlur={() => dispatch({ type: 'BLUR_FIELD', field: 'targeting' })}
            error={errorFor('targeting')}
          />
        </div>
      </div>
      <div data-testid="ad-info-row-2" className="flex gap-8">
        <div className="flex-1">
          <TextareaField
            id="line-item-audience"
            label="Audience (Optional)"
            value={state.formData.audience}
            placeholder="Define Audience"
            rows={2}
            onChange={value => dispatch({ type: 'SET_AUDIENCE', value })}
            onBlur={() => dispatch({ type: 'BLUR_FIELD', field: 'audience' })}
            error={errorFor('audience')}
          />
        </div>
        <div className="flex-1">
          <TextareaField
            id="line-item-ad-formats"
            label="Ad Formats (Optional)"
            value={state.formData.ad_formats}
            placeholder="Set ad formats"
            rows={2}
            onChange={value => dispatch({ type: 'SET_AD_FORMATS', value })}
            onBlur={() => dispatch({ type: 'BLUR_FIELD', field: 'ad_formats' })}
            error={errorFor('ad_formats')}
          />
        </div>
      </div>
    </Section>
  );
}
